import { Alignment, Button, Navbar, OverlayToaster } from '@blueprintjs/core';
import React, { createRef, useEffect } from 'react';

import Logo from './logo.svg';

import { useAppDispatch, useAppSelector, useWindowWidth } from 'hooks';
import { clearError } from 'store/general';
import styles from './Header.module.scss';

export default function Header({ toggleMenu }: { toggleMenu: () => void }) {
  const windowWith = useWindowWidth();
  const error = useAppSelector((state) => state.general.error);
  const dispatch = useAppDispatch();

  // @ts-ignore
  const toasterRef = createRef<OverlayToasterType>();

  useEffect(() => {
    if (error) {
      toasterRef.current?.show({
        intent: 'danger',
        timeout: 3500,
        isCloseButtonShown: false,
        message: error,
      });
      dispatch(clearError());
    }
  }, [error]);

  return (
    <Navbar className={styles.navbar}>
      <Navbar.Group>
        <img
          src={Logo}
          alt=""
          height={windowWith > 375 ? 50 : 40}
          width={windowWith > 375 ? 50 : 40}
        />
        <Navbar.Heading className={styles.heading}>
          JUNIOR CLIMBING OPEN
        </Navbar.Heading>
      </Navbar.Group>

      <Navbar.Group align={Alignment.RIGHT}>
        <Button
          className={styles.menuButton}
          minimal
          icon="menu"
          onClick={toggleMenu}
        />
      </Navbar.Group>
      <OverlayToaster ref={toasterRef} />
    </Navbar>
  );
}
